<script lang="ts" setup>
import {
  UIForm,
  UIFormItem,
  UIModal,
  UIModalContent,
  UIModalFooter,
  UIModalHeader,
  UIInput,
} from '@gohighlevel/ghl-ui'

import { computed, ref, watch } from 'vue'

const props = defineProps({
  show: { type: Boolean, default: false },
  defaultName: { type: String, default: '' },
})
const cloneTemplateName = ref(props.defaultName)

const rules = {
  cloneTemplateName: {
    required: true,
    message: 'Please select a template name',
    trigger: ['input', 'blur'],
    validator() {
      if (!cloneTemplateName.value) return false
      return true
    },
  },
}
const emit = defineEmits(['close:modal', 'clone:template'])
const resetFormValue = () => {
  cloneTemplateName.value = ''
}

const handleCancel = () => {
  emit('close:modal')

  resetFormValue()
}
const cloneTemplateForm = ref()
const handleSubmit = () => {
  cloneTemplateForm.value.getForm().validate()
  if (!cloneTemplateName.value) return
  emit('clone:template', cloneTemplateName.value)
  resetFormValue()
}
watch(
  () => props.defaultName,
  val => {
    cloneTemplateName.value = val
  }
)
</script>

<template>
  <UIModal :show="props.show">
    <template #header>
      <UIModalHeader
        id="pg-email-builder-modal-clone-template__clone-template-header"
        :title="$t('emailBuilder.provideTemplateName')"
        @close="handleCancel"
      />
    </template>

    <UIModalContent>
      <UIForm
        id="pg-email-builder-modal-clone-template__clone-template-form"
        :rules="rules"
        ref="cloneTemplateForm"
      >
        <UIFormItem
          :label="$t('emailBuilder.provideTemplateName')"
          path="cloneTemplateName"
          required
        >
          <UIInput
            id="pg-email-builder-rss-campaign__rss_feed_url"
            :readonly="false"
            :placeholder="$t('emailBuilder.provideTemplateName')"
            :error="false"
            v-model="cloneTemplateName"
          />
        </UIFormItem>
      </UIForm>
    </UIModalContent>
    <template #footer>
      <UIModalFooter
        id="pg-email-builder-modal-clone-template__clone-new-template-modal-footer"
        :negativeText="$t('common.cancel')"
        :positiveText="$t('common.continue')"
        @negativeClick="handleCancel"
        @positiveClick="handleSubmit"
      ></UIModalFooter>
    </template>
  </UIModal>
</template>
<style></style>
